/* eslint-disable @nx/enforce-module-boundaries */
import {
  Documents,
  FolderClosed,
  Music,
  Pictures,
  Videos,
} from '@mybridge/icons';
import {
  AIIcon,
  AVIIcon,
  CODEIcon,
  CSVIcon,
  DOCIcon,
  FILEIcon,
  JPGIcon,
  MP3Icon,
  MP4Icon,
  PDFIcon,
  PNGIcon,
  PPTIcon,
  PSDIcon,
  SVGIcon,
  WAVIcon,
  XLSIcon,
  ZIPIcon,
} from '@mybridge/icons/FileIcons';
export const FileFolderIconsMap = {
  document: Documents,
  music: Music,
  movies: Videos,
  pictures: Pictures,
  pdf: PDFIcon,
  ai: AIIcon,
  avi: AVIIcon,
  code: CODEIcon,
  csv: CSVIcon,
  doc: DOCIcon,
  file: FILEIcon,
  jpg: JPGIcon,
  jpeg: JPGIcon,
  mp3: MP3Icon,
  mp4: MP4Icon,
  png: PNGIcon,
  ppt: PPTIcon,
  pptx: PPTIcon,
  psd: PSDIcon,
  svg: SVGIcon,
  wav: WAVIcon,
  xls: XLSIcon,
  xlsx: XLSIcon,
  zip: ZIPIcon,
};

export const FileFolderIcon = ({ file, ...props }) => {
  const Icon =
    FileFolderIconsMap[file?.extension || file?.name?.split('.')[1]] ?? ((props) => <FILEIcon {...props} />);
  if (file?.type === 'D' || file?.type === 'RD')
    return <FolderClosed {...props} />;
  return <Icon {...props} />;
};
